export const algorithms = {
  noDefaultValueStrategy: {
    Key: 'no-default-value-strategy',
    Name: 'No default value for cofactor',
    Description: 'No default value would be assigned to cofactors. Guidelines standards calculation which contains cofactoring would be skipped.',
    FormComponent: '',
    ConfigComponent: 'StationDataWithFallbackStrategyConfig',
  },
  staticOverride: {
    Key: 'static-override',
    Name: 'Use a single unchanging value for each cofactor',
    Description: `A single static value is assigned to each cofactor. 
    Calculations will only use these static values 
    and will ignore values from other sources (i.e. station data).`,
    FormComponent: 'override-strategy-form',
    ConfigComponent: 'OverrideStrategyConfig',
  },
  stationDataWithFallbackValue: {
    Key: 'station-data-with-fallback-value',
    Name: 'Calculate values from same sample (with default values)',
    Description: `Each cofactor value is calculated based on station data from the same sample, if available; otherwise, the cofactor's default value is used.
    If no default value was assigned, the cofactor is skipped.`,
    FormComponent: 'station-data-strategy-form',
    ConfigComponent: 'StationDataWithFallbackStrategyConfig',
  },
}